// Generated by scripts/build-info.mjs - do not edit, not committed.
export const BUILD_INFO = {
  sha: '23c16d2720675dc313042f1a7f72c70c7d52d5ae',
  short: '23c16d2',
  builtAt: '2026-11-03T19:21:25.664Z',
} as const;
